export class DeviceParamExtV5 {

    public paramA: number;
    public paramB: number;
    public paramC: number;
    public paramD: number;
    public paramE: number;

}
